export default __webpack_public_path__ + "static/media/upnext.dd4484cb.mp4";